import { Component } from '@angular/core'
import { RouterOutlet, Router } from '@angular/router'
import { LanguageSwitch } from '../../../common/swtich/language.component'

@Component({
  selector: 'app-auth-entry',
  templateUrl: './entry.component.html',
  styleUrl: './entry.component.css',
  imports: [RouterOutlet, LanguageSwitch]
})
export class AuthEntry {
  constructor(private router: Router) {}

  get isLoginPage(): boolean {
    return this.router.url.includes('/login')
  }
}
